import Utils from "common/utils";
import Constants from 'common/constants'
import RemoteLogger from 'common/remoteLogger'

/// Class that contains all the params required to fetch weather data
export default class WeatherParams {
    constructor(lat, lon, street, city, country, zipCode, src, showSearchBar = 0, showPremiumFeature) {
        this.latitude = lat
        this.longitude = lon

        if (Utils.isNull(country)) {
            country = null
        }
        this.country = country

        if (Utils.isNull(zipCode)) {
            zipCode = null
        }
        this.zipCode = zipCode

        this.area = Utils.formatArea(
            city,
            street
        )
        this.weatherSource = src
        this.showSearchBar = showSearchBar
        this.showPremiumFeature = showPremiumFeature
    }

    static instanceFromUrl() {
        let src = Utils.getValForKeyFromCurrentUrl(Constants.ARGS.SRC)
        if (Utils.isEmptyStr(src)) {
            src = ""
        }

        // Validate the source
        switch (src) {
            case Constants.WEATHER_SRC.MANUAL:
            case Constants.WEATHER_SRC.NATIVE_GEO:
                // pass
                break;
            default:
                src = Constants.WEATHER_SRC.NATIVE_GEO
        }

        return new WeatherParams(
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.LATITUDE),
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.LONGITUDE),
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.AREA),
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.CITY),
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.COUNTRY),
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.ZIP_CODE),
            src,
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.SHOW_SEARCH_BAR),
            Utils.getValForKeyFromCurrentUrl(Constants.ARGS.SHOW_PREMIUM_FEATURE),
        )
    }

    static instanceFromRawObj(obj) {
        let instance = new WeatherParams(
            obj.latitude,
            obj.longitude,
            obj.street,
            obj.city,
            obj.country,
            obj.zipCode,
            obj.weatherSource,
        )
        instance.area = obj.area
        return instance
    }

    isEqualToObj(paramObj) {
        if (Utils.isNull(paramObj)) {
            return false;
        }
        var isEqual = (
            this.latitude === paramObj.latitude &&
            this.longitude === paramObj.longitude &&
            (
                (this.country === paramObj.country) ||
                (
                    false === Utils.isNull(this.country) && false === Utils.isNull(paramObj.country) &&
                    this.country.toLocaleLowerCase() === paramObj.country.toLocaleLowerCase()
                )
            ) &&
            this.zipCode === paramObj.zipCode &&
            this.weatherSource === paramObj.weatherSource
        )
        if (false === isEqual) {
            return false;
        }

        if (false === Utils.isNull(this.area) && false === Utils.isNull(paramObj.area)) {
            return (this.area.city === paramObj.area.city && this.area.area === paramObj.area.area)
        } else if (false === Utils.isNull(this.area) || false === Utils.isNull(paramObj.area)) {
            return false;
        }
        return true;
    }

    /**
     * Returns true if the weather-param's area values are equal.
     * More precisely, the weatherParams.area.city and weatherParams.area.area are exactly the same.
     * Not checking for any other parameters, including the lat-lon, source & zipcode parameters.
     * @param {weatherParams} paramObj
     * @returns {boolean}
     */
    areWeatherAreasEqual(paramObj) {
        if (Utils.isNull(paramObj)) {
            return false;
        }

        if (true === Utils.isNull(this.area) || true === Utils.isNull(paramObj.area)) {
            return false;
        }

        return (this.area.city === paramObj.area.city && this.area.area === paramObj.area.area)
    }

    /// Generate and update the current-url in-place
    updateUrlInPlace() {
        if (Utils.isNull(window.history)) {
            RemoteLogger.logStr("ENDPOINT: Cannot perform url-update since the window.history is not available")
            return false
        }

        var newEndpoint = this.generateUpdatedUrl(window.location.pathname, window.location.search)
        console.log("ENDPOINT: Got updated endpoint - ", newEndpoint)
        if (true === Utils.isNull(newEndpoint)) {
            RemoteLogger.logStr("ENDPOINT: Not performing update since the weather-url cannot be generated")
            return false
        }

        window.history.replaceState(null, "", newEndpoint)
        return true
    }

    /// Generate the updated url
    generateUpdatedUrl(path, queryParamsStr) {
        var newEndpoint = null
        if (Utils.isEmptyStr(path)) {
            RemoteLogger.logStr("ENDPOINT: Got empty path when generating the url")
            return newEndpoint
        }
        if (Utils.isNull(this.latitude) || Utils.isNull(this.longitude)) {
            RemoteLogger.logStr("ENDPOINT: Got empty lat-lon when generating the url")
            return newEndpoint
        }

        // Fetch the args of the current url
        var queryParams = Utils.getAllUrlParams(queryParamsStr)
        if (Utils.isNull(queryParams)) {
            queryParams = {}
        }

        // Deleting all those entries that can be potentially removed
        delete queryParams[Constants.ARGS.AREA]
        delete queryParams[Constants.ARGS.CITY]
        delete queryParams[Constants.ARGS.COUNTRY]
        delete queryParams[Constants.ARGS.ZIP_CODE]

        // Play with only those entries which can be touched
        queryParams[Constants.ARGS.LATITUDE] = this.latitude;
        queryParams[Constants.ARGS.LONGITUDE] = this.longitude;

        if (false === Utils.isNull(this.area)) {
            if (false === Utils.isEmptyStr(this.area.area)) {
                queryParams[Constants.ARGS.AREA] = this.area.area;
            }
            if (false === Utils.isEmptyStr(this.area.city)) {
                queryParams[Constants.ARGS.CITY] = this.area.city;
            }
        }

        if (false === Utils.isEmptyStr(this.country)) {
            queryParams[Constants.ARGS.COUNTRY] = this.country;
        }

        if (false === Utils.isEmptyStr(this.zipCode)) {
            queryParams[Constants.ARGS.ZIP_CODE] = this.zipCode;
        }

        let src = Constants.WEATHER_SRC.NATIVE_GEO
        if (false === Utils.isEmptyStr(this.weatherSource)) {
            switch (this.weatherSource) {
                case Constants.WEATHER_SRC.NATIVE_GEO:
                case Constants.WEATHER_SRC.MANUAL:
                    src = this.weatherSource
                    break
                default:
                // pass
            }
        }
        queryParams[Constants.ARGS.SRC] = src

        // Generate the url from queryParams object
        newEndpoint = path + "?" + Utils.encodeObjectToUrlArgs(queryParams)
        return newEndpoint
    }
}



// WEBPACK FOOTER //
// ./src/models/weatherParams.js